export default { sha: '4ba28d79809bede4db786935df41de353b278a26', buildNumber: 'undefined' }
